module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._l((_vm.errors), function(e, index) {
    return _c('ui-alert', {
      key: index,
      attrs: {
        "type": "error",
        "dismissible": false
      }
    }, [_vm._v(_vm._s(e))])
  }), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "use_template"
    },
    model: {
      value: (_vm.item.use_template),
      callback: function($$v) {
        _vm.item.use_template = $$v
      },
      expression: "item.use_template"
    }
  }, [_vm._v("Użyj szablonu")]), _vm._v(" "), (_vm.item.use_template) ? _c('p', [_vm._v("\n          Treść wiadomości zostanie wpisana do wybranego szablonu lub do domyślnego szablonu jeśli nie wybierzesz szablonu.\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.item.use_template) ? _c('div', [_c('p', [_vm._v("\n              Ponieważ nie wybrałeś \"użyj szablonu\" musisz zadbać o to aby cała wiadomość html była kompletna (była kompletną podstroną html - zawierała znaczniki html, body, head oraz link do wypisania się z newslettera).\n          ")]), _vm._v(" "), _c('p', [_c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleHelp($event)
      }
    }
  }, [_vm._v("Pokaż więcej informacji")])]), _vm._v(" "), (_vm.showHelp) ? _c('div', [_c('p', [_vm._v("\n                  Link do wypisania się z newslettera ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "name": "help",
      "disabled": true
    },
    model: {
      value: (_vm.help),
      callback: function($$v) {
        _vm.help = $$v
      },
      expression: "help"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                Link do potwierdzenia adresu e-mail\n              ")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "name": "help2",
      "disabled": true
    },
    model: {
      value: (_vm.help2),
      callback: function($$v) {
        _vm.help2 = $$v
      },
      expression: "help2"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.item.import_html_url) ? _c('ui-textbox', {
    attrs: {
      "label": "Wybrany url z którego zaimportujemy treść",
      "name": "import_html_url",
      "type": "text",
      "disabled": true
    },
    model: {
      value: (_vm.item.import_html_url),
      callback: function($$v) {
        _vm.item.import_html_url = $$v
      },
      expression: "item.import_html_url"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.item.use_template) ? _c('fieldset', [_c('legend', [_vm._v("Szablon")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_text",
      "label": "Szablon tekstowy",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_text,
      "placeholder": "Wybierz szablon",
      "required": ""
    },
    model: {
      value: (_vm.item.template_text),
      callback: function($$v) {
        _vm.item.template_text = $$v
      },
      expression: "item.template_text"
    }
  }), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "template_html",
      "label": "Szablon html",
      "keys": _vm.keysForTemplateSelect,
      "options": _vm.templates_html,
      "placeholder": "Wybierz szablon",
      "required": ""
    },
    model: {
      value: (_vm.item.template_html),
      callback: function($$v) {
        _vm.item.template_html = $$v
      },
      expression: "item.template_html"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Treść wiadomości")]), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Tytuł",
      "name": "title",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz tytuł wiadomości"
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.item.title = $$v
      },
      expression: "item.title"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    attrs: {
      "label": "Treść tekstowa",
      "name": "text_body",
      "type": "text",
      "validation-rules": "required",
      "validation-messages": _vm.errorMessages,
      "placeholder": "Wpisz treść tekstową",
      "multi-line": true,
      "rows": 4
    },
    model: {
      value: (_vm.item.text_body),
      callback: function($$v) {
        _vm.item.text_body = $$v
      },
      expression: "item.text_body"
    }
  }), _vm._v(" "), _c('ckeditor', {
    attrs: {
      "fullpage": !_vm.item.use_template,
      "value": _vm.item.html_body
    },
    on: {
      "input": _vm.inputC
    }
  }), _vm._v(" "), (!_vm.item.use_template) ? _c('a', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.importUrl($event)
      }
    }
  }, [_vm._v("Importuj treść wiadomości z podanego adresu url")]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Adresaci tej wiadomości")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_all"
    },
    model: {
      value: (_vm.item.send_to_all),
      callback: function($$v) {
        _vm.item.send_to_all = $$v
      },
      expression: "item.send_to_all"
    }
  }, [_vm._v("Wszyscy")]), _vm._v(" "), (!_vm.item.send_to_all) ? _c('div', [_c('ui-checkbox', {
    attrs: {
      "name": "send_to_confirmed"
    },
    model: {
      value: (_vm.item.send_to_confirmed),
      callback: function($$v) {
        _vm.item.send_to_confirmed = $$v
      },
      expression: "item.send_to_confirmed"
    }
  }, [_vm._v("Potwierdzone adresy e-mail")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_notconfirmed"
    },
    model: {
      value: (_vm.item.send_to_notconfirmed),
      callback: function($$v) {
        _vm.item.send_to_notconfirmed = $$v
      },
      expression: "item.send_to_notconfirmed"
    }
  }, [_vm._v("Niepotwierdzone adresy e-mail")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_imported"
    },
    model: {
      value: (_vm.item.send_to_imported),
      callback: function($$v) {
        _vm.item.send_to_imported = $$v
      },
      expression: "item.send_to_imported"
    }
  }, [_vm._v("Zaimportowani")]), _vm._v(" "), _c('ui-checkbox', {
    attrs: {
      "name": "send_to_signout"
    },
    model: {
      value: (_vm.item.send_to_signout),
      callback: function($$v) {
        _vm.item.send_to_signout = $$v
      },
      expression: "item.send_to_signout"
    }
  }, [_vm._v("Wypisani")])], 1) : _vm._e(), _vm._v(" "), _c('i-select-multiple', {
    attrs: {
      "name": "email_groups_ids",
      "label": "Grupy",
      "keys": _vm.keysForSelect,
      "options": _vm.emailGroups,
      "placeholder": "Wybierz grupy",
      "multiple": "",
      "search-placeholder": "Szukaj",
      "show-search": true,
      "required": ""
    },
    model: {
      value: (_vm.item.email_groups_ids),
      callback: function($$v) {
        _vm.item.email_groups_ids = $$v
      },
      expression: "item.email_groups_ids"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Konto z którego zostanie wysłana wiadomość")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "account",
      "label": "Konto do wysłania wiadomości",
      "keys": _vm.keysForSelect,
      "options": _vm.accounts,
      "placeholder": "Wybierz konto",
      "required": ""
    },
    model: {
      value: (_vm.item.email_account_id),
      callback: function($$v) {
        _vm.item.email_account_id = $$v
      },
      expression: "item.email_account_id"
    }
  })], 1), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Status")]), _vm._v(" "), _c('i-select', {
    attrs: {
      "name": "status",
      "label": "Status",
      "keys": _vm.keysForSelect,
      "options": _vm.statuses,
      "placeholder": "Wybierz status",
      "required": ""
    },
    model: {
      value: (_vm.item.status),
      callback: function($$v) {
        _vm.item.status = $$v
      },
      expression: "item.status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('ui-button', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Aktualizuj' : 'Dodaj'))])], 1)], 2), _vm._v(" "), _c('ui-modal', {
    ref: "modal1",
    attrs: {
      "title": _vm.modal.title,
      "hide-footer": true,
      "size": "large"
    }
  }, [_c('url-preview-form', {
    on: {
      "choose": _vm.getUrl
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de02ceca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/Form.vue
// module id = 289
// module chunks = 0